k<template>

    <div class="container">

        <app-head title="Supplier Groups" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Supplier Groups') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.supplier-groups.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="supplierGroups.meta" />
        </div>

        <div class="card">
            <data-table :items="supplierGroups.data"
                        :links="supplierGroups.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="supplierGroup in supplierGroups.data" :key="supplierGroup.id">
                    <td>
                        {{ supplierGroup.id }}
                    </td>
                    <td>
                        <inertia-link class="" :href="route('admin.supplier-groups.edit', supplierGroup)">
                            {{ supplierGroup.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <inertia-link class="" :href="route('admin.suppliers.index', {supplier_group_id: supplierGroup.id})">
                            {{ supplierGroup.suppliers_count || 0 | localizeNumber }}
                        </inertia-link>
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';


    export default {
        props: {
            filters: Object,
            supplierGroups: Object,
        },
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    number_suppliers: {label: 'Suppliers'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.supplier-groups.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>